import React from 'react';
import useOpportunitySummary from '@/hooks/swr/useOpportunitySummary';
import translate from '@/lib/intl/translate';
import { useQueryProvider } from '@/modules/QueryProvider';
import { formatCurrency } from '@/utils/currency';
import type OpportunitiesFilterParams from '../types/OpportunitiesFilterParams';
import mapQueryToFilter from '../utils/mapQueryToFilter';
import OpportunitySummary from './OpportunitySummary';

export default function OpportunitySummaries() {
  const { filters } = useQueryProvider<OpportunitiesFilterParams>();
  const { data } = useOpportunitySummary(mapQueryToFilter(filters));

  if (!data) return null;
  return (
    <div className="mb-6 grid grid-cols-2 gap-4 sm:grid-cols-3">
      <OpportunitySummary
        heading={translate('OPPORTUNITIES_SUMMARY_TOTAL_ASK')}
        value={formatCurrency(data.sumAskAmount, true)}
      />
      <OpportunitySummary
        heading={translate('OPPORTUNITIES_SUMMARY_TOTAL_EXPECTED')}
        value={formatCurrency(data.sumExpectedAmount, true)}
      />
      <OpportunitySummary
        heading={translate('OPPORTUNITIES_SUMMARY_TOTAL_PROJECTED')}
        value={formatCurrency(data.sumFactoredAmount, true)}
      />
      <OpportunitySummary
        heading={translate('OPPORTUNITIES_SUMMARY_TOTAL_WON')}
        value={formatCurrency(data.sumWonAmount, true)}
      />
      <OpportunitySummary
        heading={translate('OPPORTUNITIES_SUMMARY_WIN_RATE')}
        value={
          <>
            {data.winRate}%
            <span className="ml-3 text-text-disabled type-body4">
              {data.totalOpportunitiesWon}/{data.totalOpportunitiesClosed}
            </span>
          </>
        }
      />
      <OpportunitySummary
        heading={translate('OPPORTUNITIES_SUMMARY_LOSS_RATE')}
        value={
          <>
            {data.lossRate}%
            <span className="ml-3 text-text-disabled type-body4">
              {data.totalOpportunitiesLost}/{data.totalOpportunitiesClosed}
            </span>
          </>
        }
      />
    </div>
  );
}
